<navigation-menu [navUnderlineColor]="this.linkHoverColor"></navigation-menu>
<main>
  <article>
    <div id="article-container">
      <h1>HELLO,</h1>
      <div id="para-content">
        <p>
          To start off, I hope you’re having an an AWESOME day! 😎
        </p>
        <p>My name is <b>Ato Koomson</b>.</p>
        <p>
          I hold a <b>Computer Engineering</b> degree from York University🎓.
        </p>
        <p>
          I have spent the last few years reducing the develop-test-production cycle in enterprise environments.
          Lately, my focus has evolved from validation-automation into developing full-stack <b>AI Harness</b>🤖.
        </p>
        <p>
          Welcome to my personal corner of the internet.
        </p>
        <p>
          Explore my latest work, including <b>SemanticOS</b>, and feel free to reach out if you love building friction free software!
        </p>
      </div>
    </div>
  </article>
</main>
<contact-menu
  id="contact"
  [linkHoverColor]="this.linkHoverColor"
></contact-menu>
